var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "col" }, [
        _c("div", { staticClass: "ibox sombra-light" }, [
          _c("div", { staticClass: "ibox-title" }, [
            _c("h5", [
              _vm._v(
                "\n                    Grupos de Workers (Supervisor)\n                    "
              ),
              _vm.pendiente
                ? _c(
                    "span",
                    {
                      staticClass: "badge badge-warning ml-2",
                      attrs: {
                        title:
                          "El cambio se aplicará automáticamente en el próximo ciclo",
                      },
                    },
                    [
                      _c("i", { staticClass: "fal fa-clock" }),
                      _vm._v(
                        " Cambios pendientes de aplicar\n                    "
                      ),
                    ]
                  )
                : _c("span", { staticClass: "badge badge-success ml-2" }, [
                    _c("i", { staticClass: "fal fa-check" }),
                    _vm._v(" Configuración al día\n                    "),
                  ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "ibox-tools" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-default btn-sm",
                  attrs: { disabled: _vm.cargando },
                  on: { click: _vm.importar },
                },
                [
                  _c("i", { staticClass: "fal fa-download" }),
                  _vm._v(" Importar\n                    "),
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-info btn-sm",
                  attrs: { disabled: _vm.cargando || _vm.grupos.length === 0 },
                  on: { click: _vm.previsualizar },
                },
                [
                  _c("i", { staticClass: "fal fa-eye" }),
                  _vm._v(" Previsualizar\n                    "),
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn-primary btn btn-sm",
                  on: { click: _vm.agregar },
                },
                [
                  _c("i", { staticClass: "fal fa-plus" }),
                  _vm._v(" Agregar\n                    "),
                ]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "ibox-content" },
            [
              _vm.grupos.length === 0
                ? _c(
                    "div",
                    { staticClass: "alert alert-warning text-center" },
                    [
                      _c("strong", [_vm._v("Sin configuración cargada.")]),
                      _vm._v("\n                    Usa "),
                      _c("em", [_vm._v("Importar configuración actual")]),
                      _vm._v(" o crea el primer grupo.\n                "),
                    ]
                  )
                : _c("data-table", {
                    attrs: {
                      id: _vm.dt.id,
                      datos: _vm.dt.datos,
                      columnas: _vm.dt.columnas,
                      responsive: true,
                      "font-size": 12,
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "colas_slot",
                        fn: function (item) {
                          return _vm._l(item.data.colas, function (cola, i) {
                            return _c(
                              "span",
                              {
                                key: i,
                                staticClass: "badge badge-primary mr-1",
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(i + 1) +
                                    ". " +
                                    _vm._s(cola) +
                                    "\n                        "
                                ),
                              ]
                            )
                          })
                        },
                      },
                      {
                        key: "activo_slot",
                        fn: function (item) {
                          return [
                            _c(
                              "span",
                              {
                                class: item.data.activo
                                  ? "badge badge-success"
                                  : "badge badge-secondary",
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(item.data.activo ? "Sí" : "No") +
                                    "\n                        "
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                      {
                        key: "opciones",
                        fn: function (item) {
                          return [
                            _c("div", { staticClass: "dropdown float-right" }, [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-gray btn-sm dropdown-toggle",
                                  attrs: {
                                    type: "button",
                                    "data-toggle": "dropdown",
                                    "aria-haspopup": "true",
                                    "aria-expanded": "false",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                                Opciones\n                            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "ul",
                                {
                                  staticClass:
                                    "dropdown-menu dropdown-menu-right",
                                },
                                [
                                  _c("li", [
                                    _c(
                                      "a",
                                      {
                                        attrs: { href: "javascript:void(0)" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.editar(item.data)
                                          },
                                        },
                                      },
                                      [
                                        _c("i", { staticClass: "fal fa-edit" }),
                                        _vm._v(
                                          " Editar\n                                    "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "a",
                                      {
                                        attrs: { href: "javascript:void(0)" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.eliminar(item.data.id)
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fal fa-trash-alt",
                                        }),
                                        _vm._v(
                                          " Eliminar\n                                    "
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("FormModal", {
        ref: "FormModal",
        attrs: { tipo: _vm.tipo, grupo: _vm.seleccionado },
        on: { guardar: _vm.guardar },
      }),
      _vm._v(" "),
      _c("ModalDelete", { ref: "ModalDelete", on: { eliminar: _vm.borrar } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }